<div class="signature-component-container" [ngClass]="{'is-mobile-view': isMobileApp}">

  <!-- Changed it Mobile only -->
  <div class="ion-margin-bottom" *ngIf="isMobileApp">
    <ion-label class="rectify-title">{{ 'RECTIFY_PDF_UPLOAD_1' | translate }}</ion-label>
  </div>

  <!-- General label for both -->
  <div class="ion-margin-bottom">
    <ion-label class="signature-label">{{ 'RECTIFY_SIGNATURE_15' | translate }}</ion-label>
  </div>

  <div *ngIf="isSubmitted" class="ion-padding-bottom">
    <ion-text class="text-danger-accent">{{ 'SIGNATURE_VALIDATION' | translate }}</ion-text>
  </div>

  <div class="canvas-box">
    <canvas #signatureCanvas [hidden]="existingSignature"></canvas>
    <img *ngIf="existingSignature" [src]="existingSignature" class="signature-preview" />
  </div>
</div>